import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { AuthenticationService } from './core/services/auth.service';
import { GlobalState } from './core/services/global-state.service';
import { LoaderService } from './core/spinner/loader.service';
import { AclTipo } from './model/AclTipo.enum';
import { EntiService } from './services/enti.service';
import { EventiDataSource } from './services/eventi.datasource';
import { CambioRuoloEnteComponent } from './components/cambio-ruolo-ente-dialog/cambio-ruolo-ente-dialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  /**
   */
  public sideMenuCollapsed = false;
  public selected = new FormControl(null, null);
  public value:string;
  public enteForm: FormGroup;
  public menu: boolean = true;
  public openCloseMenu: Subject<boolean> = new Subject<boolean>();
  public iconContent: boolean = true;
  public utenteLoggato: string = 'Nessun utente loggato';
  public isUtenteLoggato: boolean = false;
  private dataSource: EventiDataSource;

  /**
   * Creates an instance of ApplicationComponent.
   */
  constructor(
    public loadService: LoaderService,
    public dialog: MatDialog,
    private state: GlobalState,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private enteSvc: EntiService,
    private translate: TranslateService,
    private router: Router,
    private authenticationService: AuthenticationService
  ) {
    translate.addLangs(['it','eng']);
    translate.setDefaultLang('it');
  }

  ngOnInit() {
  this.enteForm = new FormGroup({
    ente: new FormControl(null,null)
  })
  this.authenticationService.currentAclObservable.subscribe(acl => {
    if (acl != null) {
      this.isUtenteLoggato = true;
      if (acl.acl === AclTipo.DPCPL) {
        this.utenteLoggato = 'Dir. Protezione Civile e Polizia Locale';
      } else if (acl.acl === AclTipo.DGPE) {
        this.utenteLoggato = 'Direzione Generale Post Emergenza';
      } else if (acl.acl === AclTipo.EELL) {
        this.utenteLoggato = acl.nomeEnte;
      } else if (acl.acl === AclTipo.EDEL) {
               this.utenteLoggato = acl.nomeEnte;
      }

    } else {
      this.isUtenteLoggato = false;
      this.utenteLoggato = 'Nessun utente loggato';
    }
  })
}

showIconContent(){
  this.iconContent = !this.iconContent;
}

setLabelOnChangeValue(event){
  if(event == 2){
    this.logout();
  }else if (event == 3) {
    this.openCambioRuoloEnteDialog();
  }
  this.selected = new FormControl(null, null);
}

openCambioRuoloEnteDialog() {
  //inserire qui la configurazione della material dialog MatDialogConfig per dati e css
  const dialogConfig = new MatDialogConfig();
  dialogConfig.width = '800px';
  const dialogRef = this.dialog.open(CambioRuoloEnteComponent, dialogConfig);
}

logout(){
  this.router.navigate(['/logout']);
}

toggleMenu() {
  this.menu = !this.menu
  if(this.menu) this.openCloseMenu.next(true);
  else this.openCloseMenu.next(false);
}

}
